import "../styles/AdminInterface.css"
/* import "../styles/App.css"
 */import React, { useState, useEffect } from 'react'
import BackendAPI from "../API/BackendAPI"
import IconButton from '@mui/material/IconButton';

import { useHistory } from 'react-router-dom';
import { TextField, FormControl, InputLabel, Button,Tooltip , Divider, Typography, TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, Select, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core"
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';

import Popup from "../components/Popup"
import Sidebar from "../components/Sidebar"
import cookie from 'react-cookies'


const AdminStatistiquesApp = () => {
  // console.log("admin")
  const history = useHistory()


  const user = cookie.load("user")
  // console.log(user)
  const handleDisconnect = () => {
    // console.log("handleDisconnect")
    cookie.save('user', "disconnected", {
      path: '/',
      maxAge: 60 * 60 * 1.5, //sec
    })
    history.push('/login');
  }


  if (user === null || user === undefined || user == "disconnected") history.push("/login");
  if (user !== null && user !== undefined && user.username !== undefined && !user.username.toUpperCase().includes("ADMIN")) handleDisconnect()


  // const [actualiser,setActualiser]=useState(true)

  const [popupText, setPopupText] = useState(null)

  const [users, setUsers] = useState(null)
  const [localUsers, setLocalUsers] = useState(users);
  const [popupUser, setPopupUser] = useState(null)
  const [newUser, setNewUser] = useState(null)
  const [userList,setUserList] = useState([])
  const [localUserList, setLocalUserList] = useState([])

  // const liste_jeux = ["Tous","Compta 1 - Attaque des cupcakes", "Compta 2 - Quiz en folie", "Compta 3 - Panique au PCG","Compta 4 - Balance ton écriture","Compta 5 - Belle brioche",
  //   "Compta 6 - NOUVEAU JEU","SI 1 - Datman","SI 2 - Casse-tête ERP","SI 3 - Train de processus","SI 4 - Datacrush","SI 5 - Quiz en folie"]
  
  // const [annee, setAnnee] = useState("2025-2026")
    const now = new Date();
    const debutAnnee = (now.getMonth() > 7 || (now.getMonth() === 7 && now.getDate() >= 25))
      ? now.getFullYear()
      : now.getFullYear() - 1;
  
    const [annee, setAnnee] = useState(`${debutAnnee}-${debutAnnee + 1}`)

  const [nom, setNom] = useState('Tous');
  const [prenom, setPrenom] = useState('Tous');
  const [pseudo, setPseudo] = useState('Tous');
  const [campus, setCampus] = useState('Tous');
  const [groupes,setGroupes]=useState([])
  const [programme, setProgramme] = useState('Tous');
  const [groupe, setGroupe] = useState('Tous');

  // Données exemple pour les options des filtres
  const [anneesOptions,setAnneesOptions] = useState(["2023-2024","2024-2025","2025-2026","2026-2027","2027-2028"])

  const [nomOptions,setNomOptions] = useState([])
  const [prenomOptions,setPrenomOptions] = useState([])
  const [pseudosOptions,setPseudosOptions] = useState([])
  const [campusOptions,setCampusOptions] = useState([])
  const [programmeOptions,setProgrammeOptions] = useState([])
  const [groupesOptions,setGroupesOptions] = useState([])

  const handleFilterChange = (setter) => (event) => {
    setter(event.target.value);
  };

  useEffect(() => {
    const getStatistiqueApp = async () => {

      const response = await BackendAPI.getStatistiquesApp()
      // console.log(response)
      setUserList(response);

      const groupes = await BackendAPI.getGroupes()
      setGroupes(groupes)
    };

    getStatistiqueApp();
  }, []);


  const getUniqueValues = (data, attribute,campus, programme, groupe) => {

    if(data==null ) return []

    const filtered_data = data
        .filter((val)=>val.campus==campus || campus == "Tous" || attribute=="campus")
        .filter((val)=>val.programme==programme || programme == "Tous" || attribute=="campus" || attribute=="programme")
        .filter((val)=>val.groupe==groupe || groupe == "Tous" || attribute=="campus"  || attribute=="programme" || attribute=="groupe")

    const values = filtered_data?.map(item => {
      if (attribute === "numJeu") {
        return item[attribute] - 10; // Si l'attribut est 'numJeu', soustraire 10
      }
      return item[attribute]; // Sinon, retourner la valeur normale de l'attribut
    });
  
    const uniqueValues = [...new Set(values)].filter((val)=>val!="").sort(); 
    uniqueValues.unshift("Tous"); 
    return uniqueValues;
  };

  useEffect(() => {
    if (userList !== null && userList.length>0) {
      setNomOptions(getUniqueValues(userList,"nom",campus, programme, groupe))
      setPrenomOptions(getUniqueValues(userList,"prenom",campus, programme, groupe))
      setPseudosOptions(getUniqueValues(userList,"pseudo",campus, programme, groupe))
      // setCampusOptions(getUniqueValues(userList,"campus"))
      // setGroupesOptions(getUniqueValues(userList,"groupe"))
      filterAndGroupList(userList)
    }
  }, [userList])

  useEffect(()=>{
      if (groupes !== null && groupes.length>0) {
        setCampusOptions(getUniqueValues(groupes,"campus",campus, programme, groupe))
        setProgrammeOptions(getUniqueValues(groupes,"programme",campus, programme, groupe))
        setGroupesOptions(getUniqueValues(groupes,"groupe",campus, programme, groupe))
      }
      
    },[groupes,campus,programme])
  
    useEffect(()=>{
      if( groupes.filter((val)=> val.programme== programme && val.campus==campus).length==0){
        setProgramme("Tous")
      }
  
       if( groupes.filter((val)=> val.programme== programme && val.campus==campus && val.groupe == groupe).length==0){
        setGroupe("Tous")
      }
      
    },[campus])
  
    useEffect(()=>{   
      if( groupes.filter((val)=>val.groupe== groupe && val.programme== programme && val.campus == campus).length==0){
        setGroupe("Tous")
      }
    },[programme])
  
    useEffect(()=>{
      if(groupe!="Tous"){
        setProgramme(groupes.filter((val)=>val.groupe== groupe)[0].programme)
        setCampus(groupes.filter((val)=>val.groupe== groupe)[0].campus)
      }
    },[groupe])




  const filterAndGroupList=(userList)=>{


function isDateInRange(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return false;

  const p = dateStr.split("-");
  if (p.length < 2) return false;
  const inputDate = new Date(+p[0], (+p[1]) - 1, p[2] ? +p[2] : 1);
  if (isNaN(inputDate)) return false;

  const year = parseInt(annee.split("-")[0], 10);
  const startDate = new Date(year, 7, 25);       // 25 août
  const endDate   = new Date(year + 1, 7, 24);   // 24 août

  return inputDate >= startDate && inputDate <= endDate;
}

    const groupedByUser = userList
      .filter((user) => (annee && annee!="Tous" ? isDateInRange(user.premiereConnexionApplication): true))
      .filter((user) => (nom && nom!="Tous" ? user.nom==nom: true))
      .filter((user) => (prenom && prenom!="Tous" ? user.prenom==prenom: true))
      .filter((user) => (pseudo && pseudo!="Tous" ? user.pseudo==pseudo: true))
      .filter((user) => (campus && campus!="Tous" ? user.campus==campus: true))
      .filter((user) => (programme && programme!="Tous" ? user.programme==programme: true))
      .filter((user) => (groupe && groupe!="Tous" ? user.groupe==groupe: true))
      
      .reduce((acc, curr) => {

      const { idUser, bestScore } = curr;
  
      // Vérifier si l'utilisateur existe déjà dans l'accumulateur
      if (!acc[idUser]) {
          acc[idUser] = { ...curr, totalBestScore: bestScore };
      } else {
          acc[idUser].totalBestScore += bestScore;
      }
  
      return acc;
    }, {});
  
    setLocalUserList( Object.values(groupedByUser));
    return Object.values(groupedByUser)
  }

  useEffect(()=>{
    
    const localUserList=filterAndGroupList(userList)
   
if (nom=="Tous"){

      if(groupe=="Tous"){
        
        if(campus=="Tous"){
          
          
          if(pseudo=="Tous"){
            setPrenomOptions(getUniqueValues(userList,"prenom",campus, programme, groupe))
            setNomOptions(getUniqueValues(userList,"nom",campus, programme, groupe))
            setPseudosOptions(getUniqueValues(userList,"pseudo",campus, programme, groupe))
            // setCampusOptions(getUniqueValues(userList,"campus"))
            // setGroupesOptions(getUniqueValues(userList,"groupe"))
          }else{
            setPrenomOptions(getUniqueValues(localUserList,"prenom",campus, programme, groupe))
            setNomOptions(getUniqueValues(localUserList,"nom",campus, programme, groupe))
            setPseudosOptions(getUniqueValues(localUserList,"pseudo",campus, programme, groupe))
            // setCampusOptions(getUniqueValues(localUserList,"campus"))
            // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
          }

        }else{
          setPrenomOptions(getUniqueValues(localUserList,"prenom",campus, programme, groupe))
          setNomOptions(getUniqueValues(localUserList,"nom",campus, programme, groupe))
          setPseudosOptions(getUniqueValues(localUserList,"pseudo",campus, programme, groupe))
          // setCampusOptions(getUniqueValues(localUserList,"campus"))
          // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
        }


      }else{
        setPrenomOptions(getUniqueValues(localUserList,"prenom",campus, programme, groupe))
        setNomOptions(getUniqueValues(localUserList,"nom",campus, programme, groupe))
        setPseudosOptions(getUniqueValues(localUserList,"pseudo",campus, programme, groupe))
        // setCampusOptions(getUniqueValues(localUserList,"campus"))
        // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
      }

    }else{
      setPrenomOptions(getUniqueValues(localUserList,"prenom",campus, programme, groupe))
      setNomOptions(getUniqueValues(localUserList,"nom",campus, programme, groupe))
      setPseudosOptions(getUniqueValues(localUserList,"pseudo",campus, programme, groupe))
      // setCampusOptions(getUniqueValues(localUserList,"campus"))
      // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
    }
    
  },[annee,nom,prenom,pseudo,campus,programme,groupe])

const formatDate = (dateString) => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
};

const renderStatistiqueApp = () => {
  if (userList !== null && userList.length > 0) {
    return (
      <TableContainer component={Paper} style={{ maxHeight: "100%" }} >
        <Table stickyHeader aria-label="customized table">
          <TableHead>
            <TableRow key={"HEAD"}>
              {/* <TableCell align="center" style={{ width: 80 }}>Rang</TableCell> */}
              <TableCell align="center" style={{ width: 150 }}>Nom</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Prénom</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Pseudo</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Campus</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Programme</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Groupe</TableCell>
              <TableCell align="center" style={{ width: 200 }}>Première connexion</TableCell>
              <TableCell align="center" style={{ width: 200 }}>Nombre ouvertures</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {localUserList
              .map((u, index) => (
                <TableRow key={u.id} style={{ height: 40 }}>
                  <TableCell align="center">{u.nom}</TableCell>
                  <TableCell align="center">{u.prenom}</TableCell>
                  <TableCell align="center">{u.pseudo}</TableCell>
                  <TableCell align="center">{u.campus}</TableCell>
                  <TableCell align="center">{u.programme}</TableCell>
                  <TableCell align="center">{u.groupe}</TableCell>
                  <TableCell align="center">{formatDate(u.premiereConnexionApplication)}</TableCell>
                  <TableCell align="center">{u.nbOuverturesApplication}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
};


const exportToCSV = () => {
  if (!localUserList || localUserList.length === 0) {
    alert("Aucun utilisateur à exporter !");
    return;
  }

  // Définition des colonnes CSV
  const headers = ["Nom", "Prénom", "Pseudo","Email",  "Campus","Programme", "Groupe","Première connexion","Nombre ouvertures"];

  // Génération des lignes
  const rows = localUserList
  .sort((a, b) => b.nbOuverturesApplication - a.nbOuverturesApplication) // tri décroissant par score
  .map((u, index) => [
    u.nom,
    u.prenom,
    u.pseudo,
    u.email,
    u.campus,
    u.programme,
    u.groupe,
    u.premiereConnexionApplication,
    u.nbOuverturesApplication
  ]);

  // Transformation en texte CSV
  const csvContent = [
    headers.join(";"), // séparateur ;
    ...rows.map(row => row.join(";"))
  ].join("\n");

  // Création du fichier Blob
  // const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
  // Création d'un lien de téléchargement temporaire
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);


  link.setAttribute("download", "Statistiques application.csv");
  
  

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div
        className="body-admin"
      >
        <Typography variant="h1" color="primary">Statistiques Application</Typography>
        <Divider />
        {/* {
        popupText!=null ?
        <Popup open={true} text={popupText} reponse={"Supprimer Utilisateur"} handleClose={handleClosePopup} ></Popup>
        :
        null
      } */}
        <div style={{ margin: 10 }}  >
          <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
            <FormControl size="small" variant="outlined">
              <InputLabel>Année</InputLabel>
              <Select
                value={annee}
                variant="outlined"
                onChange={handleFilterChange(setAnnee) }
              >
                {anneesOptions.map(c => (
                  <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
                ))}
              </Select>
            </FormControl>
            
            <FormControl size="small" variant="outlined">
            <InputLabel>Nom</InputLabel>
              <Select
                value={nom}
                onChange={handleFilterChange(setNom)}
                label="Nom"
              >
                      {nomOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" variant="outlined">
              <InputLabel>Prénom</InputLabel>
              <Select
                value={prenom}
                onChange={handleFilterChange(setPrenom)}
                label="Prénom"
              >
                      {prenomOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Pseudo */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Pseudo</InputLabel>
              <Select
                value={pseudo}
                onChange={handleFilterChange(setPseudo)}
                label="Pseudo"
              >

                {pseudosOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Campus */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Campus</InputLabel>
              <Select
                value={campus}
                onChange={handleFilterChange(setCampus)}
                label="Campus"
              >

                {campusOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" variant="outlined">
              <InputLabel>Programme</InputLabel>
              <Select
                value={programme}
                onChange={handleFilterChange(setProgramme)}
                label="Programme"
              >

                {programmeOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Groupe */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Groupe</InputLabel>
              <Select
                value={groupe}
                onChange={handleFilterChange(setGroupe)}
                label="Groupe"
              >

                {groupesOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <IconButton aria-label="download" style={{padding:10}} onClick={exportToCSV}>
              <DownloadIcon  />
            </IconButton>
          </div>
          <br></br>
          {renderStatistiqueApp()}

          {/*   <br></br>
          <Typography variant="h5" color="primary">Créer un nouvel étudiant</Typography>

          {renderNewUser()} */}
          {/* {newUser.nom} {newUser.prenom} {newUser.email} ({newUser.campus} - {newUser.groupe}) */}
        </div>



        {/* </div> */}

      </div></div>
  );
}

export default AdminStatistiquesApp;

